import RuleEditor from "./RuleEditor";

export default function RuleCreate() {
  return <RuleEditor mode="create" />;
}